'use client';

import { Box, Paper } from '@mui/material';

import { AvatarSection, ProfileFormSection } from '@/components';
// import { useChangePasswordForm } from '@/hooks';
import type { User } from '@/types';

export interface ProfileSectionProps {
  user: User;
  name: string;
  avatarUrl: string | null;
  isSaving: boolean;
  hasChanges: boolean;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
  isUploading?: boolean;
  onAvatarUpload?: () => void;
  onFileChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRef?: React.RefObject<HTMLInputElement>;
}

export function ProfileSection({
  user,
  name,
  avatarUrl,
  isSaving,
  hasChanges,
  onNameChange,
  onSave,
  isUploading,
  onAvatarUpload,
  onFileChange,
  fileInputRef,
}: ProfileSectionProps) {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <AvatarSection
          avatarUrl={avatarUrl}
          userName={name || user?.name || ''}
          isUploading={isUploading}
          onAvatarUpload={onAvatarUpload}
          onFileChange={onFileChange}
          fileInputRef={fileInputRef}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 4,
            alignItems: 'stretch',
          }}
        >
          <ProfileFormSection
            name={name}
            email={user.email}
            phone={user.phone}
            isSaving={isSaving}
            hasChanges={hasChanges}
            onNameChange={onNameChange}
            onSave={onSave}
          />
        </Box>
      </Paper>
    </Box>
  );
}
